import { LoadingStatus, StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  loading: boolean
  isInactive: boolean
  isActive: boolean
  isCancelled: boolean
}

export const ActivationStatus = ({ loading, isInactive, isActive, isCancelled }: IProps) => {
  if (loading) {
    return <LoadingStatus />
  }

  const getStatusText = () => {
    // if (!data) {
    //   return 'no data'
    // }

    if (isInactive) return 'inactive'

    if (isActive) return 'active'

    if (isCancelled) return 'cancelled'

    return 'no data'
  }

  return (
    <StatusWidgetContainer>
      <div className='text-text-muted text-center px-[6px] py-[4px] rounded-[12px] flex flex-col items-center justify-between gap-[2px] h-[50px] sm:h-[60px] w-[58px]'>
        <div className='grow px-[3px] rounded-[5px] sm:pt-[2px] flex items-center justify-center'>
          {/* {!data && <commonIcons.cancel className='text-[22px] sm:text-[24px]' />} */}
          {isInactive && <commonIcons.warning className='text-[22px] sm:text-[24px]' />}
          {isActive && <commonIcons.checkCircle className='text-[22px] sm:text-[24px]' />}
          {isCancelled && <commonIcons.cancel className='text-[22px] sm:text-[24px]' />}
        </div>

        <div className='uppercase jost-medium text-[9px] sm:text-[9px] sm:pb-[3px]'>{getStatusText()}</div>
      </div>
    </StatusWidgetContainer>
  )
}
